"use client"

import { useLanguage } from "../contexts/LanguageContext"
import { usePrivacyPolicy } from "../contexts/PrivacyPolicyContext"

const PrivacyPolicyPage = () => {
  const { language } = useLanguage()
  const { policy } = usePrivacyPolicy()
  const isRtl = language === "he"

  // Add top margin to avoid header overlap
  const pageStyle = {
    padding: "40px 0",
    marginTop: "100px",
  }

  return (
    <section
      className={`privacy-page ${isRtl ? "rtl-text" : ""}`}
      style={{
        ...pageStyle,
        direction: isRtl ? "rtl" : "ltr",
        textAlign: isRtl ? "right" : "left",
      }}
      dir={isRtl ? "rtl" : "ltr"}
    >
      <div className="container">
        <div style={{ maxWidth: "900px", margin: "0 auto" }}>
          <h1 style={{ fontSize: "2rem", marginBottom: "0.5rem" }}>{policy.title}</h1>
          {policy.updatedAt && (
            <p style={{ marginBottom: "2rem", color: "#777" }}>{policy.updatedAt}</p>
          )}

          {policy.sections.map((section) => (
            <div key={section.id} style={{ marginBottom: "1.75rem" }}>
              <h2 style={{ fontSize: "1.25rem", marginBottom: "0.5rem" }}>{section.heading}</h2>
              {section.content.map((paragraph, index) => (
                <p key={index} style={{ marginBottom: "0.5rem", lineHeight: 1.7 }}>{paragraph}</p>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default PrivacyPolicyPage
